import { FormFieldProps } from "../../types/components.types";
import Button from "../layout/Button";

const FormField: React.FC<FormFieldProps> = ({
  // An array of objects, each representing an input field.
  inputFields,
  // A callback func. triggered when the form is submitted.
  onSubmit,
  // Optional prop to disable the submit button (e.g., while loading).
  disabled = false,
  testIdPrefix,
}) => {
  // Handle form submission.
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="input-with-button">
          {inputFields.map((field) => (
            <input
              key={field.id}
              type={field.type}
              placeholder={field.placeholder}
              // The current value of the input field.
              value={field.value}
              // Trigger onChange with the new value as the user types.
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              className="form-control"
              data-testid={testIdPrefix ? `${testIdPrefix}-input-${field.id}` : undefined}
            />
          ))}
          <Button
            type="submit"
            disabled={disabled}
            testId={testIdPrefix ? `${testIdPrefix}-submit` : undefined}
          >
            Submit
          </Button>
        </div>
      </div>
    </form>
  );
};

export default FormField;
